<template>
  <div class="bootcamp-materials">
    <div class="bootcamp-materials__selectors">
      <button
        @click="currentSelection = 'overview'"
        v-if="bootcamp.overview_html"
        :class="[
          'bootcamp-materials__selector',
          currentSelection === 'overview' &&
            'bootcamp-materials__selector--selected',
        ]"
      >
        Overview
      </button>
      <button
        @click="currentSelection = 'instructions'"
        v-if="bootcamp.instructions_html"
        :class="[
          'bootcamp-materials__selector',
          currentSelection === 'instructions' &&
            'bootcamp-materials__selector--selected',
        ]"
      >
        Instructions
      </button>
      <button
        @click="currentSelection = 'materials'"
        v-if="bootcamp.files && bootcamp.files.length"
        :class="[
          'bootcamp-materials__selector',
          currentSelection === 'materials' &&
            'bootcamp-materials__selector--selected',
        ]"
      >
        Reference Material
      </button>
    </div>
    <div class="bootcamp-materials__content">
      <Overview
        v-if="currentSelection === 'overview'"
        :overview="bootcamp.overview_html || ''"
      />
      <Instructions
        v-if="currentSelection === 'instructions'"
        :instructions="bootcamp.instructions_html || ''"
      />
      <ReferenceMaterials
        v-if="currentSelection === 'materials' && hasAccess"
        :files="files"
        :bootcamp="bootcamp"
        :hasAccess="hasAccess"
      />
      <div
        class="bootcamp-materials__access-action"
        v-if="currentSelection === 'materials' && !hasAccess"
      >
        <img
          class="bootcamp-materials__restricted-img"
          src="@/assets/images/subscriptions/unlock-premium.png"
          alt="Unlock to premium"
        />
        <h5 class="bootcamp-materials__premium-cta">
          Unlock This Content<span v-if="canUpgradePlan">, Upgrade Today!</span>
        </h5>
        <p class="bootcamp-materials__premium-description">
          Bootcamp content and materials are only available to Premium
          subscribers.
        </p>
        <button
          v-if="canUpgradePlan"
          class="bootcamp-materials__access-btn btn__large"
          @click="$emit('requestPlanUpgrade')"
        >
          UPGRADE
          <LockIcon
            class="btn__large-icon bootcamp-materials__access-btn--icon"
          />
        </button>
        <a
          v-else
          class="btn__large bootcamp-materials__access-btn"
          :href="`//${plansLink}`"
          id="ine-link"
        >
          GET ACCESS
          <LockIcon
            class="btn__large-icon bootcamp-materials__access-btn--icon"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LockIcon from '@/assets/icons/course/lock_icon.svg'
import Overview from './bootcamp-materials/Overview.vue'
import Instructions from './bootcamp-materials/Instructions.vue'
import ReferenceMaterials from './bootcamp-materials/ReferenceMaterials.vue'

export default {
  name: 'BootcampMaterials',
  components: {
    Overview,
    Instructions,
    ReferenceMaterials,
    LockIcon: { ...LockIcon, name: 'LockIcon' },
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    files: {
      type: Object,
      required: false,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    canUpgradePlan: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      currentSelection: 'materials',
    }
  },
  computed: {
    ...mapState({
      plansLink: state => state.app.plansLink,
    }),
  },
  mounted() {
    if (this.bootcamp.instructions_html) this.currentSelection = 'instructions'
    if (this.bootcamp.overview_html) this.currentSelection = 'overview'
  },
}
</script>

<style lang="scss">
.bootcamp-materials {
  h3 {
    font-size: rem(18px);
    color: var(--orange);
    padding: 0;
    margin: 0;
    text-transform: uppercase;
  }
  &__selectors {
    padding: 0 0 15px 0;
    border-bottom: 1px solid var(--darker-gray);
    display: flex;
    justify-content: space-between;
    @include mobile {
      justify-content: flex-start;
    }
  }
  &__selector {
    border: none;
    background: none;
    color: var(--white);
    font-size: rem(14px);
    padding: 0;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    @include mobile {
      font-size: rem(22px);
      margin: 0 25px 0 0;
    }
    &--selected {
      position: relative;
      &:after {
        position: absolute;
        left: 0;
        bottom: -17px;
        content: '';
        width: 100%;
        height: 3px;
        background: var(--orange);
      }
    }
  }
  &__content {
    margin: 25px 0 0 0;
    margin-bottom: 2rem;
    ul {
      list-style-type: none;
      list-style-type: none;
      column-count: 2;
      padding: 10px;
      li {
        text-indent: -26px;
        padding-left: 20px;
        margin-bottom: 10px;
        break-inside: avoid-column;
        page-break-inside: avoid;
      }
      li:before {
        content: 'check';
        color: var(--green);
        margin-right: 10px;
        font-family: 'Material Icons';
      }
    }
  }
  &__access-action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__premium-cta {
    display: flex;
    align-items: center;
    font-family: var(--font-bold);
    font-size: rem(16px);
    color: white;
    font-size: 30px;
    margin: 0 0 20px 0;
  }
  &__access-btn {
    max-width: 180px;
    text-align: left;
    display: flex;
    align-items: center;
    &--icon {
      position: relative;
      margin: -8px -15px 0 25px;
      @include desktop {
        margin: -8px -25px 0 25px;
      }
    }
  }
  &__premium-description {
    color: var(--white);
    font-size: 15px;
    margin-bottom: 3rem;
  }
  &__restricted-img {
    max-width: 200px;
    @include desktop {
      max-width: 400px;
    }
  }
}
</style>
